/* eslint-disable better-mutation/no-mutation */

import cookieUtil from 'tradera/utils/cookie';
import { MYTRADERA_DEFAULT_COOKIES } from 'tradera/constants/cookies';
import { logger } from 'packages/logger';
import { createSlice } from '@reduxjs/toolkit';

const defaultState = () => {
    const defaultCookies = {};
    Object.keys(MYTRADERA_DEFAULT_COOKIES).forEach((value) => {
        const val = cookieUtil.readCookie(MYTRADERA_DEFAULT_COOKIES[value].key);
        defaultCookies[value] = val
            ? val
            : MYTRADERA_DEFAULT_COOKIES[value].default;
    });
    return defaultCookies;
};

const cookiesSlice = createSlice({
    name: 'cookies',
    initialState: defaultState(),
    reducers: {
        setCookie: {
            reducer: (state, { payload }) => {
                if (state[payload.name] !== payload.value) {
                    state[payload.name] = payload.value;
                }
            },
            prepare: (payload) => {
                const { length, key } = MYTRADERA_DEFAULT_COOKIES[payload.name];
                try {
                    cookieUtil.createCookie(key, payload.value, length);
                } catch (e) {
                    logger(e);
                }
                return { payload };
            },
        },
    },
});

export default cookiesSlice.reducer;

export const { setCookie } = cookiesSlice.actions;

export const selectCookiesState = (state) => state.views.myTradera.cookies;
